<template>
  <v-expansion-panels>
    <v-expansion-panel :model-value="0" role="presentation" :disabled="disablePaymentDetailsLink">
      <v-card color="lighten-4" flat rounded="0" class="pa-4 mb-4">
        <!-- Payment Details -->
        <ExpandedPaymentCard v-if="!paymentMethodChangeAlert" @editPayMethod="editPayMethod" />
        <!-- Changing your method of payment will cancel your bank draft -->
        <AlertChangePayment
          v-if="paymentMethodChangeAlert"
          @cancel="cancelEditPaymentMethod"
          @goToStepOne="changePaymentMethod"
        />
      </v-card>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'pinia';
import AlertChangePayment from './ChangePaymentMethod/AlertChangePayment.vue';
import ExpandedPaymentCard from './ExpandedPaymentCard/ExpandedPaymentCard.vue';
import { usePolicyStore } from '@/modules/policy/store/policy.store';

export default defineComponent({
  name: 'ViewPaymentDetails',
  components: {
    ExpandedPaymentCard,
    AlertChangePayment,
  },
  props: {
    payNow: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(usePolicyStore, {
      currentPolicy: 'currentPolicy',
      panelValue: 'panelValue',
      paymentMethodChangeAlert: 'getPaymentMethodChangeAlert',
      disablePaymentDetailsLink: 'getDisablePaymentDetailsLink',
    }),
    panelOpen() {
      return this.panelValue === 0 ? 'true' : 'false';
    },
    kubraPaymentInProgress() {
      return this.currentPolicy?.kubraPaymentStatus !== null;
    },
  },
  methods: {
    ...mapActions(usePolicyStore, {
      setDisablePaymentDetailsLink: 'setDisablePaymentDetailsLink',
      setPanelValue: 'setPanelValue',
      setPaymentMethodChangeAlert: 'setPaymentMethodChangeAlert',
      setEditPaymentMethod: 'setEditPaymentMethod',
    }),
    editPayMethod() {
      if (this.currentPolicy.isB2BillingForm) {
        this.setPaymentMethodChangeAlert(true);
      } else {
        this.setDisablePaymentDetailsLink(true);
        this.setEditPaymentMethod(true);
      }
    },
    cancelEditPaymentMethod() {
      this.setDisablePaymentDetailsLink(false);
      this.setPaymentMethodChangeAlert(false);
      this.setEditPaymentMethod(false);
    },
    changePaymentMethod() {
      this.setDisablePaymentDetailsLink(true);
      this.setPaymentMethodChangeAlert(false);
      this.setEditPaymentMethod(true);
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.disabled-link + div i.v-icon) {
  color: gray !important;
}
</style>
